import { Injectable } from '@angular/core';
import { SectionMessage, SectionReview } from './review-section.domain';
import { Observable } from 'rxjs';
import { StoreItem } from '../../stores/StoreItem';
import { areEqualOrBothEmpty } from '../../helpers/common.helper';

@Injectable({
  providedIn: 'root',
})
export class ReviewSectionStore {
  constructor() {}

  private _sectionMessages: StoreItem<SectionMessage[]> = new StoreItem<SectionMessage[]>([]);
  private _sectionReviews: StoreItem<SectionReview[]> = new StoreItem<SectionReview[]>([]);
  private _isLockedReviews: StoreItem<boolean> = new StoreItem<boolean>(false);

  public get sectionMessages(): Observable<SectionMessage[]> {
    return this._sectionMessages.getObservable();
  }

  public setSectionMessages(sectionMessages: SectionMessage[]) {
    this._sectionMessages.setValue(sectionMessages);
  }

  public addSectionMessage(sectionMessage: SectionMessage) {
    this.setSectionMessages([...this._sectionMessages.getValue(), sectionMessage]);
  }

  public get reviews(): Observable<SectionReview[]> {
    return this._sectionReviews.getObservable();
  }

  public setReviews(reviews: SectionReview[]) {
    this._sectionReviews.setValue(reviews);
  }

  public updateReview(review: SectionReview) {
    const reviewsValue = this._sectionReviews.getValue() || [];
    const indexOfExisting = reviewsValue.findIndex(
      r => r.application_id === review.application_id && r.section === review.section && areEqualOrBothEmpty(r.entity_id, review.entity_id)
    );
    if (indexOfExisting !== -1) {
      let updatedReviews = [...reviewsValue];
      updatedReviews[indexOfExisting] = review;
      this.setReviews(updatedReviews);
      return;
    }

    this.setReviews([...reviewsValue, review]);
  }

  public setLockReviews(isLocked: boolean) {
    this._isLockedReviews.setValue(isLocked);
  }

  public getLockReviews(): Observable<boolean> {
    return this._isLockedReviews.getObservable();
  }
}
